export default __webpack_public_path__ + "static/arrow-dark-green-a7d28370b321adf6964c732caeb565ab.png";